<template>
    <v-snackbar
        class="alert"
        v-model="sharedState.alert"
        :top="true"
        :right="true"
        absolute
        multi-line
        :color="sharedState.alertColor">
        {{sharedState.alertMessage}}
        <v-btn text small @click="sharedState.alert = false">Close</v-btn>
    </v-snackbar>
</template>

<script>
import store from '@/services/business/store';

export default {
    name: 'AlertComponent',
    data: () => {
        return {
            sharedState: store.state
        }
    }
};
</script>

<style lang="scss" scoped>
    // .alert {
        // position: fixed;
        // top: 20px;
        // right: 20px;
        // max-width: 400px;
    // }
</style>